import React from 'react';
import FormHistory from 'modules/FormHistory';

const DaTerms = ({ contact, portfolioUuid, profileUuid }) => {
  const isCompany = contact.type === 'COMPANY';
  const key = isCompany
    ? 'c_da_terms'
    : 'p_da_terms';

  return <FormHistory
    formKey={key}
    contactName={contact.name}
    portfolioUuid={portfolioUuid}
    profileUuid={profileUuid}
  />;
};

export default DaTerms;
